import React from 'react'
import { Popup as SemanticPopup, StrictPopupProps } from 'semantic-ui-react'

import Truncated from './Truncated'
import './styles.css'

const DEFAULT_POPPER_MODIFIERS = [
  { name: 'preventOverflow', options: { boundary: 'viewport' } },
  { name: 'flip', options: { fallbackPlacements: ['bottom', 'right', 'left'] } },
]

export type PopupProps = Omit<StrictPopupProps, 'trigger' | 'content' | 'children'> & {
  children?: React.ReactNode
  tooltip?: React.ReactNode
  content?: React.ReactNode
  popperModifiers?: StrictPopupProps['popperModifiers']
}

function Popup({ children, tooltip, content, popperModifiers, className, ...rest }: PopupProps) {
  const mergedClassName = ['ss-popup', className].filter(Boolean).join(' ')
  return (
    <SemanticPopup
      basic
      inverted
      flowing
      position="top center"
      className={mergedClassName}
      popperModifiers={[...(popperModifiers || []), ...DEFAULT_POPPER_MODIFIERS]}
      trigger={children}
      {...rest}
    >
      {tooltip ?? content}
    </SemanticPopup>
  )
}

Popup.Truncated = Truncated

export default Popup



// WEBPACK FOOTER //
// ./src/shared/components/Popup/index.tsx